var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStores = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_storage_2128117",
    width: 28.536,
    height: 28.538,
    viewBox: "0 0 28.536 28.538",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19175",
    "data-name": "Path 19175",
    d: "M31.044,30.55H29.568V11.982l1.21.777a.491.491,0,1,0,.531-.827L17.534,3.077a.462.462,0,0,0-.074-.03L17.362,3a.659.659,0,0,0-.093,0,.531.531,0,0,0-.089,0,.418.418,0,0,0-.108.044.339.339,0,0,0-.064.025L3.231,11.923a.494.494,0,1,0,.526.836l1.21-.777V30.55H3.492a.492.492,0,1,0,0,.984H31.044a.492.492,0,0,0,0-.984ZM5.952,11.362,17.268,4.076l11.316,7.287V30.55h-5.9V19.234a.492.492,0,0,0-.492-.492h-9.84a.492.492,0,0,0-.492.492V30.55h-5.9ZM12.84,30.55V19.726H21.7V30.55Z",
    transform: "translate(-3 -2.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19177",
    "data-name": "Path 19177",
    d: "M30.552,47H25.427a.416.416,0,1,0,0,.832h5.125a.416.416,0,1,0,0-.832Z",
    transform: "translate(-13.501 -26.024)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStores, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Stores.243bfa64.svg";
export { ForwardRef as ReactComponent };